import React from "react";
import { Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { trackCall, trackEmail } from "@/lib/track";
import { FormEmbed } from "./FormEmbed";

export const ContactAndMap: React.FC = () => {
  return (
    <section id="contact" className="py-20 bg-[#FAF8F5] text-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-16">
          {/* Left - Info */}
          <div className="lg:col-span-6 space-y-8">
            <div>
              <span className="text-xs sm:text-sm uppercase tracking-widest text-[#B38D30] font-bold block mb-2">
                GET IN TOUCH
              </span>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-stone-900 tracking-tight mb-4">
                Get in Touch
              </h2>
              <p className="text-stone-600 text-base leading-relaxed">
                From the first visit to the finished floor, we keep you informed
                and stick to our schedule. Just fill in the form or give us a
                call.
              </p>
            </div>

            <div className="space-y-6">
              {/* Call Us */}
              <div className="flex items-start gap-4">
                <div className="p-3.5 rounded-xl bg-[#C9A84C]/20 text-[#B38D30] shrink-0">
                  <Phone className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-stone-900 text-base">
                    Call Us
                  </h4>
                  <a
                    href="tel:077657126609"
                    onClick={() => trackCall("07765 712609", "contact_section")}
                    className="text-[#B38D30] font-bold text-lg hover:underline block"
                  >
                    07765 712609
                  </a>
                  <a
                    href="tel:07470861869"
                    onClick={() => trackCall("07470 861869", "contact_section")}
                    className="text-[#B38D30] font-bold text-lg hover:underline block"
                  >
                    07470 861869
                  </a>
                  <span className="text-stone-500 text-xs">
                    Call us for a free quote
                  </span>
                </div>
              </div>

              {/* Email Us */}
              <div className="flex items-start gap-4">
                <div className="p-3.5 rounded-xl bg-[#C9A84C]/20 text-[#B38D30] shrink-0">
                  <Mail className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-stone-900 text-base">
                    Email Us
                  </h4>
                  <a
                    href="mailto:efscreed@gmail.com"
                    onClick={() =>
                      trackEmail("efscreed@gmail.com", "contact_section")
                    }
                    className="text-[#B38D30] font-semibold text-sm sm:text-base hover:underline block break-all"
                  >
                    efscreed@gmail.com
                  </a>
                  <span className="text-stone-500 text-xs">
                    Or use the form on the right
                  </span>
                </div>
              </div>

              {/* Business Hours */}
              <div className="flex items-start gap-4">
                <div className="p-3.5 rounded-xl bg-[#C9A84C]/20 text-[#B38D30] shrink-0">
                  <Clock className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-stone-900 text-base">
                    Business Hours
                  </h4>
                  <p className="text-stone-700 text-sm">
                    <span className="font-medium">Monday – Saturday:</span> 7 am
                    – 6 pm
                  </p>
                  <p className="text-stone-500 text-sm">
                    <span className="font-medium">Sunday:</span> Closed
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Form */}
          <div className="lg:col-span-6 bg-white border border-stone-200 rounded-2xl p-6 sm:p-8 shadow-xl">
            <div className="w-full">
              <FormEmbed instanceId="contact" height={480} lazy />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
